import { rem } from 'polished';
import styled from 'styled-components';

export default styled('div')`
  height: 100%;
  display: flex;
  justify-content: center;
  padding-top: ${rem(30)};
`;
